import React, {Component} from 'react';
import {Row, Col} from 'react-bootstrap';

class WiderImage extends Component {
  render(){
    let { image, alt } = this.props;
    return(
      <Row className="le-wider-image">
        <Col md={12}>
          <img src={image} alt={alt}/>
        </Col>
      </Row>
    )
  }
}

export default WiderImage;